import { Card, Col, Row } from "antd";
import { Link } from "react-router-dom";

export default function FooterComponent({ footer }) {
  


  return (
    <Row justify='center' gutter={[10, 10]} style={{backgroundColor: '#fff',borderRadius: 15, padding: 10, width: '100%',boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)'}}>

      <hr style={{ border: '1px solid lightgray', width: '100%' }} />
        {footer && footer.map((item, index) => (
      <Col key={index} style={{ textAlign: 'center' }}>
          <Card style={{  boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
            <Row justify='center' gutter={[10, 10]}>
              <Col span={24} style={{ textAlign: 'center' }}>
                <p style={{ fontSize: 12, color: '#1677ff' }}>{item?.label}</p>
              </Col>
              {item?.website &&
              <Col style={{ textAlign: 'center' }}>
                <Link to={item?.website} target='_blank'><i className="fa-solid fa-globe"></i></Link>
              </Col>
              }
              {item?.facebook &&
                <Col style={{ textAlign: 'center' }}>
                <Link to={item?.facebook} target='_blank'><i className="fa-brands fa-facebook"></i></Link>
              </Col>
              }
              {item?.instagram &&
                <Col style={{ textAlign: 'center' }}>
                <Link to={item?.instagram} target='_blank'><i className="fa-brands fa-instagram"></i></Link>
              </Col>
              }
            </Row>
          </Card>
      </Col>

        ))  }
    </Row>
  )
}